/* SUITBASE Cart-Upsell „Noch was vergessen?“ – Custom Element ueberlebt Impact-Drawer-Refresh */
(() => {
  if (customElements.get('sb-cart-upsell')) return;
  let pending = false;
  const needed = items => { let u = 0, d = 0; items.forEach(i => { const h = i.handle || '', q = +i.quantity || 0;
    if (h === 'suitbase®-pro-v4-2er-bundle') u += q * 2; else if (h === 'suitbase®-pro-v4-3er-bundle') u += q * 3; else if (h.includes('pro-v4-')) u += q;
    if (h.startsWith('detail-')) d += q; }); return Math.max(0, u - d); };
  class CartUpsell extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const rail = this.querySelector('.sbcu__rail'), arrows = [...this.querySelectorAll('[data-up-dir]')];
      const sync = () => { if (!rail) return; arrows[0] && (arrows[0].disabled = rail.scrollLeft <= 2); arrows[1] && (arrows[1].disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2); };
      rail && rail.addEventListener('scroll', sync, { passive:true }); requestAnimationFrame(sync);
      this.addEventListener('click', async e => {
        const arr = e.target.closest('[data-up-dir]');
        if (arr) { const card = rail.querySelector('.sbcu__card'); const step = card ? card.getBoundingClientRect().width + 8 : rail.clientWidth * .8; rail.scrollBy({ left: step * Number(arr.dataset.upDir), behavior:'smooth' }); return; }
        const chip = e.target.closest('[data-up-chip]');
        if (chip) {
          const card = chip.closest('[data-up-washer]');
          card.querySelectorAll('[data-up-chip]').forEach(c => c.setAttribute('aria-pressed', String(c === chip)));
          const img = card.querySelector('img'); if (img) { img.removeAttribute('srcset'); img.src = chip.dataset.img; }
          card.querySelector('[data-up-wname]').textContent = chip.dataset.name;
          card.querySelector('[data-up-add]').dataset.id = chip.dataset.id;
          return;
        }
        const btn = e.target.closest('[data-up-add]');
        if (!btn || pending) return;
        pending = true; btn.setAttribute('aria-busy', 'true');
        const st = this.querySelector('[data-up-status]'); st.textContent = '';
        const root = window.Shopify?.routes?.root || '/';
        try {
          let qty = 1;
          if (btn.dataset.qty === 'washer') {
            const c = await (await fetch(root + 'cart.js')).json();
            qty = needed(c.items);
            if (!qty) { document.dispatchEvent(new CustomEvent('cart:refresh')); return; }
          }
          const r = await fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[{ id:Number(btn.dataset.id), quantity:qty }] }) });
          const res = await r.json();
          if (!r.ok) throw new Error(res.description || 'Hinzufügen fehlgeschlagen.');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (location.pathname.replace(/\/$/, '').endsWith('/cart')) location.reload();
        } catch (err) { st.textContent = err.message; }
        finally { pending = false; btn.removeAttribute('aria-busy'); }
      });
    }
  }
  customElements.define('sb-cart-upsell', CartUpsell);
})();
